import CryptoJS from 'crypto-js'
import { SecretPass } from '../config'

export const encryptData = (data) => {
    return CryptoJS.AES.encrypt(data, SecretPass).toString();
}

export const decryptData = (data) => {
    return CryptoJS.AES.decrypt(data, SecretPass).toString(CryptoJS.enc.Utf8)
}